import { Brand, Divider, Modal, ModalVariant } from '@patternfly/react-core'
import * as React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import styled from 'styled-components'

import logoImgSrc from '@app/assets/images/intake-logo.png'
import { formatIsoDateTime } from '@app/i18n/formats'
import type { AppState } from '@app/state'
import {
  formatVersionInfo,
  isVersionInfoValid,
} from '@app/state/config/config.helpers'
import type { IAppVersionInfo } from '@app/state/config/interfaces'

const BrandContainer = styled.div`
  margin: 1rem;
`

const Contact = styled.div`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`

const ProductVersion = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  padding-top: 0.5rem;

  .label {
    text-decoration: underline;
  }

  .version {
    font-weight: bold;
  }
`
function renderVersionInfo(label: string, versionInfo?: IAppVersionInfo) {
  return (
    <div className="version-info">
      <div className="label">{label}</div>
      {isVersionInfoValid(versionInfo) ? (
        <React.Fragment>
          <div className="version">{formatVersionInfo(versionInfo)}</div>
          <div className="build-date-time">
            {formatIsoDateTime(versionInfo.buildDateTime)}
          </div>
        </React.Fragment>
      ) : (
        <div className="version">Invalid Version Data</div>
      )}
    </div>
  )
}

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const AboutModal = ({ isOpen, onClose }: Props) => {
  const clientVersionInfo = useSelector<AppState, IAppVersionInfo>(
    (state) => state.config.client?.versionInfo,
    shallowEqual,
  )

  const apiVersionInfo = useSelector<AppState, IAppVersionInfo>(
    (state) => state.config.api?.versionInfo,
    shallowEqual,
  )

  return (
    <Modal
      variant={ModalVariant.small}
      title="About"
      isOpen={isOpen}
      onClose={onClose}
    >
      <BrandContainer>
        <Brand src={logoImgSrc} alt={''} />
      </BrandContainer>
      <Contact>
        <p>Cohesic Inc.</p>
        <p>Suite A21 - 6120 2 Street SE</p>
        <p>Calgary, AB T2H 2L8</p>
      </Contact>
      <Divider />
      <ProductVersion>
        {renderVersionInfo('Client Version', clientVersionInfo)}
        {renderVersionInfo('Server Version', apiVersionInfo)}
      </ProductVersion>
    </Modal>
  )
}
